import React from 'react'
import './profile.css'
// eslint-disable-next-line react/prop-types
const Logout = ({ logoutUser }) => {
  return (
        <button className="btn btn-dark mt-20" onClick={logoutUser}>Log out</button>
  )
}
export default Logout
